import React from 'react';
import EditPovsExpertiseListPage from '../../../../pages/EditPovsExpertiseListPage';
import PovsExpertisePage from '../../../../pages/PovsExpertisePage';
import PovsExpertisesPage from '../../../../pages/PovsExpertisesPage';
import PovsLkPage from '../../../../pages/PovsLkPage';
import { RoutePathsType } from '../../../../types';
import { routerPath } from '../../../routerPath';

export const povsRoutes: RoutePathsType = [
  {
    path: routerPath.povsLk,
    name: 'Личный кабинет',
    Component: <PovsLkPage />,
  },
  {
    path: routerPath.povsLkDocuments,
    name: 'Экспертизы',
    Component: <PovsExpertisesPage />,
  },
  {
    path: routerPath.povsLkExpertiseId,
    name: 'Экспертизы',
    Component: <PovsExpertisePage />,
  },
  {
    path: routerPath.povsEditElId,
    name: 'Редактирование ЭЛ',
    Component: <EditPovsExpertiseListPage />,
  },
];
